import { useEffect, useState, useRef, useContext } from 'react';
import {
  AgentPage,
  AgentDetail,
  UploadPhotoWrapper,
  UploadPhotoIcon,
  InputFile,
  AgentInfoWrapper,
  AgentEmailPasswordWrapper,
  InputGroup,
  AgentNameWrapper,
  AgentDetailsWrapper,
  AgentDetailsInput,
  AgentDetailExtra,
  AgentContactContainer,
  AgentContactWrapper,
  AgentContactListItem,
  Input,
  AgentAdditionalDetailsContainer,
  AgentOfficeAddress,
  AgentCompanyWebsite,
  AgentCityStateServedContainer,
  AgentCityStateServed,
  AgentDetailsBio,
  AgentFooter,
  IconWrapper,
  AgentDetailsInputGroup,
} from '../../components/agent';
import { INIT_DATA } from '../../components/agent/data';
import { getUserType } from '../../utils/common';
import { checkEmail, getOfficers, updateCommunityPhotos } from '../../services/admin';
import { hasMinimumCharacters, isEmpty, isValidEmail } from '../../utils/form';
import { styled } from 'styled-components';
import { MainContext } from '../../context';
import ReactCrop from 'react-image-crop';
import { Box, Button, Dialog } from '@mui/material';
import { CropLoading, CropperButtons } from './editagent';
import Loader from '../../components/loader';
import centerAspectCrop from '../../utils/centerAspectRatio';
import getCroppedImg from '../../utils/getCroppedImage';
import { AGENT_PROFILE_URL } from '../../constants/common';
import Select from 'react-select';

export const FieldErrorMessage = styled.p`
  color: red !important;
  font-weight: 300 !important;
  font-size: 16px !important;
`;
const AddAgent = ({ handleSubmit, isSubmitting, fieldErrors = {} }) => {
  const imgRef = useRef(null);
  const [showEditPhoto, setShowEditPhoto] = useState(false);
  const [showUploadPhoto, setShowUploadPhoto] = useState(false);
  const [error, setError] = useState(false);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [cropLoading, setCropLoading] = useState(true);
  const [crop, setCrop] = useState({ unit: '%', width: 50, aspect: 1 });
  const [data, setData] = useState(INIT_DATA);
  const [_fieldErrors, _setFieldErrors] = useState(fieldErrors);
  const isAdmin = getUserType() == 2;
  const [silentlyUploading, setSilentlyUploading] = useState(false);
  const { activeAgent, setActiveAgent } = useContext(MainContext);
  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    setData({
      ...data,
      [name]: value,
    });

    _setFieldErrors({
      ..._fieldErrors,
      [name]: '',
    });
  };

  const handleEmailCheck = async (e) => {
    const { name, value } = e.target;
    const checkEmailResponse = await checkEmail({ email: value });
    if (checkEmailResponse.result) {
      setData({
        ...data,
        [name]: value,
      });
    } else {
      _setFieldErrors({
        ..._fieldErrors,
        email: checkEmailResponse.errors.email,
      });
    }
  };
  // eslint-disable-next-line no-unused-vars
  const handleSelectChange = (name, sdata) => {
    setData({
      ...data,
      [name]: sdata,
    });
  };

  const [previewImage, setPreviewImage] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setData({
        ...data,
        photo: file,
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setShowEditPhoto(true);
        setCropLoading(false);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    _setFieldErrors(fieldErrors);
  }, [fieldErrors]);

  const [officers, setOfficers] = useState([])
  useEffect(() => {
    async function fetchOfficers() {
      const result = await getOfficers();
      setOfficers(result.results)
    }

    fetchOfficers()
  }, [])

  const {
    email,
    password,
    first_name,
    last_name,
    brokerage,
    company_website,
    personal_website,
    company_phone,
    mobile_phone,

    description,
    // eslint-disable-next-line no-unused-vars
    photo,
    // eslint-disable-next-line no-unused-vars
    title,
    // eslint-disable-next-line no-unused-vars
    mls,
    // eslint-disable-next-line no-unused-vars
    licenses,
    // eslint-disable-next-line no-unused-vars
    ywh_ext_num,
    // eslint-disable-next-line no-unused-vars
    team_name,
    // eslint-disable-next-line no-unused-vars
    agent_type,
    // eslint-disable-next-line no-unused-vars
    cities_served,
    // eslint-disable-next-line no-unused-vars
    states_served,
    // eslint-disable-next-line no-unused-vars
    communities_served,
    // eslint-disable-next-line no-unused-vars
    office_address,
    // eslint-disable-next-line no-unused-vars
    compensation_plan,
    showingnew_identifier,
    subdomain,
    loan_officer,
  } = data;

  const [typePassword, setTypePassword] = useState(true);

  const handleChangeFiles = async (_, value, files) => {
    //silently upload to edit community route
    setSilentlyUploading(true);
    const result = await updateCommunityPhotos({
      community_id: value,
      photos: files,
    });

    setSilentlyUploading(false);
  };

  const refEmail = useRef();
  const refPassword = useRef();
  const refFirstName = useRef();
  const refBrokerage = useRef();
  const refMobilePhone = useRef();
  const refDescription = useRef();

  useEffect(() => setActiveAgent(data), [data]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(email)) {
      _setFieldErrors({
        ..._fieldErrors,
        email: 'Email is required.',
      });
      refEmail.current.scrollIntoView();
    } else if (!isValidEmail(email)) {
      _setFieldErrors({
        ..._fieldErrors,
        email: 'Email is not valid.',
      });
      refEmail.current.scrollIntoView();
    } else if (!hasMinimumCharacters(password, 8)) {
      _setFieldErrors({
        ..._fieldErrors,
        password: 'Password must be at least 8 characters',
      });
      refPassword.current.scrollIntoView();
    } else if (isEmpty(first_name)) {
      _setFieldErrors({
        ..._fieldErrors,
        first_name: 'First name is required',
      });
      refFirstName.current.scrollIntoView();
    } else if (isEmpty(last_name)) {
      _setFieldErrors({
        ..._fieldErrors,
        last_name: 'Last name is required',
      });
      refFirstName.current.scrollIntoView();
    } else if (isEmpty(mobile_phone)) {
      _setFieldErrors({
        ..._fieldErrors,
        mobile_phone: 'Mobile phone is required',
      });
      refMobilePhone.current.scrollIntoView();
    } else if (isEmpty(brokerage)) {
      _setFieldErrors({
        ..._fieldErrors,
        brokerage: 'Brokerage is required',
      });
      refBrokerage.current.scrollIntoView();
    } else handleSubmit(data);
  };

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;

    setCrop(centerAspectCrop(width, height, 1));
  };

  const handleSavePhoto = async () => {
    setCropLoading(true);
    try {
      const imageData = await getCroppedImg(imgRef.current, completedCrop);

      const { blob, base64Image } = imageData;
      setPreviewImage(base64Image);
      setData({ ...data, photo: blob });
      setShowEditPhoto(false);
    } catch (error) {
      console.log(error);
    } finally {
      setCropLoading(false);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} method="POST">
      <AgentPage>
        <Dialog open={showEditPhoto} onClose={() => setShowEditPhoto(false)} maxWidth="lg">
          {cropLoading ? (
            <CropLoading>
              <Loader />
            </CropLoading>
          ) : (
            <>
              <ReactCrop
                crop={crop}
                onChange={(_, percentCrop) => setCrop(percentCrop)}
                onComplete={(c) => setCompletedCrop(c)}
                aspect={1}
              >
                <Box
                  component="img"
                  src={previewImage}
                  width="100%"
                  ref={imgRef}
                  sx={{ mx: 'auto' }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
              <CropperButtons>
                <Button onClick={handleSavePhoto}>SAVE</Button>
              </CropperButtons>
            </>
          )}
        </Dialog>
        <AgentDetail>
          <UploadPhotoWrapper>
            {previewImage && !error ? (
              <>
                <img
                  style={{ objectFit: 'cover', objectPosition: 'top center' }}
                  src={previewImage?.includes('data') ? previewImage : AGENT_PROFILE_URL + data.photo}
                  alt="Preview"
                  onClick={() => document.getElementById('photo').click()}
                  onMouseEnter={() => setShowUploadPhoto(true)}
                  onError={() => setError(true)}
                />
                {showUploadPhoto && (
                  <UploadPhotoIcon
                    onMouseLeave={() => setShowUploadPhoto(false)}
                    onClick={() => document.getElementById('photo').click()}
                    style={{ borderRadius: '50%', backgroundColor: 'rgb(0, 0, 0, .7)', position: 'absolute' }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
                      <path
                        d="M61.1975 43.347C60.2506 43.347 59.3424 43.7232 58.6728 44.3928C58.0033 45.0624 57.6271 45.9705 57.6271 46.9175V48.2743L52.3428 42.99C50.477 41.1389 47.9552 40.1002 45.3269 40.1002C42.6986 40.1002 40.1768 41.1389 38.311 42.99L35.8117 45.4893L26.957 36.6346C25.0651 34.8337 22.5531 33.8293 19.9411 33.8293C17.329 33.8293 14.8171 34.8337 12.9251 36.6346L7.64089 41.9189V21.9244C7.64089 20.9774 8.01706 20.0693 8.68664 19.3997C9.35623 18.7301 10.2644 18.3539 11.2113 18.3539H36.2044C37.1514 18.3539 38.0595 17.9778 38.7291 17.3082C39.3987 16.6386 39.7749 15.7304 39.7749 14.7835C39.7749 13.8366 39.3987 12.9284 38.7291 12.2588C38.0595 11.5892 37.1514 11.2131 36.2044 11.2131H11.2113C8.37051 11.2131 5.64604 12.3416 3.63728 14.3503C1.62851 16.3591 0.5 19.0836 0.5 21.9244V64.7697C0.5 67.6105 1.62851 70.335 3.63728 72.3438C5.64604 74.3525 8.37051 75.481 11.2113 75.481H54.0566C56.8975 75.481 59.6219 74.3525 61.6307 72.3438C63.6395 70.335 64.768 67.6105 64.768 64.7697V46.9175C64.768 45.9705 64.3918 45.0624 63.7222 44.3928C63.0526 43.7232 62.1445 43.347 61.1975 43.347ZM11.2113 68.3401C10.2644 68.3401 9.35623 67.964 8.68664 67.2944C8.01706 66.6248 7.64089 65.7166 7.64089 64.7697V52.0232L17.9952 41.6689C18.5197 41.1691 19.2165 40.8902 19.9411 40.8902C20.6656 40.8902 21.3624 41.1691 21.887 41.6689L33.2053 52.9872L48.5582 68.3401H11.2113ZM57.6271 64.7697C57.6219 65.4532 57.3966 66.1168 56.9844 66.662L40.8817 50.4879L43.381 47.9886C43.637 47.7274 43.9425 47.5198 44.2797 47.3781C44.6169 47.2364 44.979 47.1634 45.3448 47.1634C45.7105 47.1634 46.0726 47.2364 46.4098 47.3781C46.747 47.5198 47.0525 47.7274 47.3085 47.9886L57.6271 58.3786V64.7697ZM74.4439 12.2485L63.7325 1.53716C63.393 1.2121 62.9926 0.957296 62.5543 0.787363C61.685 0.430254 60.71 0.430254 59.8408 0.787363C59.4025 0.957296 59.0021 1.2121 58.6625 1.53716L47.9512 12.2485C47.2789 12.9208 46.9011 13.8327 46.9011 14.7835C46.9011 15.7343 47.2789 16.6462 47.9512 17.3185C48.6235 17.9908 49.5354 18.3685 50.4862 18.3685C51.437 18.3685 52.3489 17.9908 53.0212 17.3185L57.6271 12.6769V32.6357C57.6271 33.5826 58.0033 34.4908 58.6728 35.1604C59.3424 35.83 60.2506 36.2062 61.1975 36.2062C62.1445 36.2062 63.0526 35.83 63.7222 35.1604C64.3918 34.4908 64.768 33.5826 64.768 32.6357V12.6769L69.3738 17.3185C69.7058 17.6532 70.1007 17.9188 70.5357 18.1C70.9708 18.2813 71.4375 18.3746 71.9089 18.3746C72.3802 18.3746 72.8469 18.2813 73.282 18.1C73.7171 17.9188 74.1119 17.6532 74.4439 17.3185C74.7785 16.9866 75.0441 16.5917 75.2254 16.1566C75.4067 15.7215 75.5 15.2548 75.5 14.7835C75.5 14.3122 75.4067 13.8455 75.2254 13.4104C75.0441 12.9753 74.7785 12.5804 74.4439 12.2485Z"
                        fill="#A8A8A8"
                      />
                    </svg>
                    <h5>UPLOAD PHOTO</h5>
                  </UploadPhotoIcon>
                )}
              </>
            ) : (
              <UploadPhotoIcon onClick={() => document.getElementById('photo').click()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
                  <path
                    d="M61.1975 43.347C60.2506 43.347 59.3424 43.7232 58.6728 44.3928C58.0033 45.0624 57.6271 45.9705 57.6271 46.9175V48.2743L52.3428 42.99C50.477 41.1389 47.9552 40.1002 45.3269 40.1002C42.6986 40.1002 40.1768 41.1389 38.311 42.99L35.8117 45.4893L26.957 36.6346C25.0651 34.8337 22.5531 33.8293 19.9411 33.8293C17.329 33.8293 14.8171 34.8337 12.9251 36.6346L7.64089 41.9189V21.9244C7.64089 20.9774 8.01706 20.0693 8.68664 19.3997C9.35623 18.7301 10.2644 18.3539 11.2113 18.3539H36.2044C37.1514 18.3539 38.0595 17.9778 38.7291 17.3082C39.3987 16.6386 39.7749 15.7304 39.7749 14.7835C39.7749 13.8366 39.3987 12.9284 38.7291 12.2588C38.0595 11.5892 37.1514 11.2131 36.2044 11.2131H11.2113C8.37051 11.2131 5.64604 12.3416 3.63728 14.3503C1.62851 16.3591 0.5 19.0836 0.5 21.9244V64.7697C0.5 67.6105 1.62851 70.335 3.63728 72.3438C5.64604 74.3525 8.37051 75.481 11.2113 75.481H54.0566C56.8975 75.481 59.6219 74.3525 61.6307 72.3438C63.6395 70.335 64.768 67.6105 64.768 64.7697V46.9175C64.768 45.9705 64.3918 45.0624 63.7222 44.3928C63.0526 43.7232 62.1445 43.347 61.1975 43.347ZM11.2113 68.3401C10.2644 68.3401 9.35623 67.964 8.68664 67.2944C8.01706 66.6248 7.64089 65.7166 7.64089 64.7697V52.0232L17.9952 41.6689C18.5197 41.1691 19.2165 40.8902 19.9411 40.8902C20.6656 40.8902 21.3624 41.1691 21.887 41.6689L33.2053 52.9872L48.5582 68.3401H11.2113ZM57.6271 64.7697C57.6219 65.4532 57.3966 66.1168 56.9844 66.662L40.8817 50.4879L43.381 47.9886C43.637 47.7274 43.9425 47.5198 44.2797 47.3781C44.6169 47.2364 44.979 47.1634 45.3448 47.1634C45.7105 47.1634 46.0726 47.2364 46.4098 47.3781C46.747 47.5198 47.0525 47.7274 47.3085 47.9886L57.6271 58.3786V64.7697ZM74.4439 12.2485L63.7325 1.53716C63.393 1.2121 62.9926 0.957296 62.5543 0.787363C61.685 0.430254 60.71 0.430254 59.8408 0.787363C59.4025 0.957296 59.0021 1.2121 58.6625 1.53716L47.9512 12.2485C47.2789 12.9208 46.9011 13.8327 46.9011 14.7835C46.9011 15.7343 47.2789 16.6462 47.9512 17.3185C48.6235 17.9908 49.5354 18.3685 50.4862 18.3685C51.437 18.3685 52.3489 17.9908 53.0212 17.3185L57.6271 12.6769V32.6357C57.6271 33.5826 58.0033 34.4908 58.6728 35.1604C59.3424 35.83 60.2506 36.2062 61.1975 36.2062C62.1445 36.2062 63.0526 35.83 63.7222 35.1604C64.3918 34.4908 64.768 33.5826 64.768 32.6357V12.6769L69.3738 17.3185C69.7058 17.6532 70.1007 17.9188 70.5357 18.1C70.9708 18.2813 71.4375 18.3746 71.9089 18.3746C72.3802 18.3746 72.8469 18.2813 73.282 18.1C73.7171 17.9188 74.1119 17.6532 74.4439 17.3185C74.7785 16.9866 75.0441 16.5917 75.2254 16.1566C75.4067 15.7215 75.5 15.2548 75.5 14.7835C75.5 14.3122 75.4067 13.8455 75.2254 13.4104C75.0441 12.9753 74.7785 12.5804 74.4439 12.2485Z"
                    fill="#A8A8A8"
                  />
                </svg>
                <h5>UPLOAD PHOTO</h5>
              </UploadPhotoIcon>
            )}
            <InputFile name="photo" type="file" accept="image/*" id="photo" onChange={handleImageChange} />
          </UploadPhotoWrapper>
          <AgentInfoWrapper>
            <AgentEmailPasswordWrapper>
              <InputGroup className={(_fieldErrors.email && 'has-error') || ''}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26" fill="none">
                  <path
                    d="M10.17 24.5C10.0569 24.1787 9.99944 23.8406 10 23.5V16.5C10 15.732 10.289 15.03 10.764 14.5H3C2.20435 14.5 1.44129 14.8161 0.87868 15.3787C0.316071 15.9413 0 16.7044 0 17.5V18.215C0 21.933 4.21 24.5 10 24.5H10.17ZM16 6.5C16 4.9087 15.3679 3.38258 14.2426 2.25736C13.1174 1.13214 11.5913 0.5 10 0.5C8.4087 0.5 6.88258 1.13214 5.75736 2.25736C4.63214 3.38258 4 4.9087 4 6.5C4 8.0913 4.63214 9.61742 5.75736 10.7426C6.88258 11.8679 8.4087 12.5 10 12.5C11.5913 12.5 13.1174 11.8679 14.2426 10.7426C15.3679 9.61742 16 8.0913 16 6.5ZM13.5 14.5C12.837 14.5 12.2011 14.7634 11.7322 15.2322C11.2634 15.7011 11 16.337 11 17V17.191L17.5 20.441L24 17.191V17C24 16.337 23.7366 15.7011 23.2678 15.2322C22.7989 14.7634 22.163 14.5 21.5 14.5H13.5ZM24 18.309L17.724 21.447C17.6545 21.4818 17.5778 21.5 17.5 21.5C17.4222 21.5 17.3455 21.4818 17.276 21.447L11 18.31V23C11 23.663 11.2634 24.2989 11.7322 24.7678C12.2011 25.2366 12.837 25.5 13.5 25.5H21.5C22.163 25.5 22.7989 25.2366 23.2678 24.7678C23.7366 24.2989 24 23.663 24 23V18.309Z"
                    fill="#A8A8A8"
                  />
                </svg>
                <Input
                  ref={refEmail}
                  name="email"
                  tabIndex={0}
                  value={email}
                  onBlur={handleEmailCheck}
                  onChange={handleInputChange}
                  type="email"
                  placeholder="Email"
                />
              </InputGroup>
              {_fieldErrors.email && <FieldErrorMessage>{_fieldErrors.email}</FieldErrorMessage>}

              <InputGroup className={(_fieldErrors.password && 'has-error') || ''}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26" fill="none">
                  <path
                    d="M10.5 0.25C8.9087 0.25 7.38258 0.882141 6.25736 2.00736C5.13214 3.13258 4.5 4.6587 4.5 6.25C4.5 7.8413 5.13214 9.36742 6.25736 10.4926C7.38258 11.6179 8.9087 12.25 10.5 12.25C12.0913 12.25 13.6174 11.6179 14.7426 10.4926C15.8679 9.36742 16.5 7.8413 16.5 6.25C16.5 4.6587 15.8679 3.13258 14.7426 2.00736C13.6174 0.882141 12.0913 0.25 10.5 0.25ZM3.0135 13.75C2.61845 13.7484 2.22698 13.8248 1.86154 13.9749C1.49609 14.1249 1.16386 14.3456 0.883889 14.6243C0.603921 14.903 0.381727 15.2343 0.230049 15.5991C0.0783718 15.9638 0.000194268 16.355 0 16.75C0 19.2865 1.2495 21.199 3.2025 22.4455C4.7745 23.4475 6.795 24.0175 9 24.19V22.75C9 22.135 9.243 21.58 9.6615 21.1615L13.5315 17.2915C13.5108 17.0801 13.5002 16.8679 13.5 16.6555C13.4934 15.6324 13.7684 14.6272 14.295 13.75H3.015H3.0135ZM10.7235 25.528C10.7915 25.599 10.8732 25.6553 10.9638 25.6935C11.0543 25.7316 11.1517 25.7509 11.25 25.75H14.25C14.3931 25.7499 14.534 25.7138 14.6595 25.645C14.7594 25.5848 14.8376 25.4945 14.883 25.387C14.9305 25.2745 14.9618 25.1558 14.976 25.0345C14.9917 24.9066 14.9997 24.7779 15 24.649V24.25C15.36 24.2425 15.6405 24.2305 15.8445 24.2155C16.0128 24.2131 16.1746 24.1503 16.3005 24.0385C16.4106 23.9159 16.473 23.7578 16.476 23.593C16.491 23.398 16.5 23.1175 16.5 22.75H17.25C17.415 22.75 17.547 22.7155 17.649 22.645C17.7465 22.5789 17.8267 22.4904 17.883 22.387C17.94 22.2772 17.9757 22.1576 17.988 22.0345C18.003 21.9025 18.012 21.7645 18.012 21.625C18.0042 21.5117 18.0002 21.3981 18 21.2845V20.992C18.258 21.0865 18.519 21.1525 18.7845 21.1915C19.0515 21.2305 19.32 21.25 19.5945 21.25C20.1783 21.2489 20.7557 21.1289 21.2916 20.8973C21.8275 20.6657 22.3106 20.3274 22.7115 19.903C23.1165 19.48 23.433 19 23.6595 18.4615C23.886 17.9215 24 17.3515 24 16.75C24 16.1245 23.883 15.5395 23.649 14.992C23.4233 14.4582 23.0968 13.9728 22.6875 13.5625C22.277 13.1537 21.7917 12.8278 21.258 12.6025C20.7023 12.3659 20.1039 12.246 19.5 12.25C18.9094 12.261 18.3258 12.38 17.778 12.601C17.2438 12.8161 16.7575 13.1347 16.347 13.5385C15.9351 13.9429 15.6015 14.4199 15.363 14.9455C15.1197 15.4825 14.9958 16.0659 15 16.6555C15 17.023 15.0435 17.41 15.129 17.8165L10.722 22.222C10.6508 22.2901 10.5944 22.3722 10.5562 22.463C10.5181 22.5538 10.4989 22.6515 10.5 22.75V25C10.5 25.2025 10.575 25.3795 10.722 25.528H10.7235ZM21.4215 14.8285C21.5278 14.9318 21.6117 15.0557 21.6682 15.1927C21.7247 15.3297 21.7526 15.4768 21.75 15.625C21.7526 15.7732 21.7247 15.9203 21.6682 16.0573C21.6117 16.1943 21.5278 16.3182 21.4215 16.4215C21.3182 16.5278 21.1943 16.6117 21.0573 16.6682C20.9203 16.7247 20.7732 16.7526 20.625 16.75C20.4768 16.7526 20.3297 16.7247 20.1927 16.6682C20.0557 16.6117 19.9318 16.5278 19.8285 16.4215C19.7222 16.3182 19.6383 16.1943 19.5818 16.0573C19.5253 15.9203 19.4974 15.7732 19.5 15.625C19.5 15.313 19.6095 15.0475 19.8285 14.8285C19.9318 14.7222 20.0557 14.6383 20.1927 14.5818C20.3297 14.5253 20.4768 14.4974 20.625 14.5C20.937 14.5 21.2025 14.6095 21.4215 14.8285Z"
                    fill="#A8A8A8"
                  />
                </svg>

                <Input
                  name="password"
                  ref={refPassword}
                  type={typePassword ? 'password' : 'text'}
                  minLength={8}
                  value={password}
                  onChange={handleInputChange}
                  placeholder="Password"
                />
                <IconWrapper onClick={() => setTypePassword(!typePassword)}>
                  {' '}
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                    <path
                      d="M11 5C10.2044 5 9.44129 5.31607 8.87868 5.87868C8.31607 6.44129 8 7.20435 8 8C8 8.79565 8.31607 9.55871 8.87868 10.1213C9.44129 10.6839 10.2044 11 11 11C11.7956 11 12.5587 10.6839 13.1213 10.1213C13.6839 9.55871 14 8.79565 14 8C14 7.20435 13.6839 6.44129 13.1213 5.87868C12.5587 5.31607 11.7956 5 11 5ZM11 13C9.67392 13 8.40215 12.4732 7.46447 11.5355C6.52678 10.5979 6 9.32608 6 8C6 6.67392 6.52678 5.40215 7.46447 4.46447C8.40215 3.52678 9.67392 3 11 3C12.3261 3 13.5979 3.52678 14.5355 4.46447C15.4732 5.40215 16 6.67392 16 8C16 9.32608 15.4732 10.5979 14.5355 11.5355C13.5979 12.4732 12.3261 13 11 13ZM11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5Z"
                      fill="#A8A8A8"
                    />
                  </svg>
                </IconWrapper>
              </InputGroup>
              {_fieldErrors.password && <FieldErrorMessage>{_fieldErrors.password}</FieldErrorMessage>}
            </AgentEmailPasswordWrapper>
            <AgentNameWrapper>
              <Input
                className={(_fieldErrors.first_name && 'has-error') || ''}
                placeholder="First Name"
                ref={refFirstName}
                minLength={4}
                name="first_name"
                value={first_name}
                onChange={handleInputChange}
              />
              {_fieldErrors.first_name && <FieldErrorMessage>{_fieldErrors.first_name}</FieldErrorMessage>}

              <Input
                className={(_fieldErrors.last_name && 'has-error') || ''}
                placeholder="Last Name"
                name="last_name"
                value={last_name}
                onChange={handleInputChange}
              />
              {_fieldErrors.last_name && <FieldErrorMessage>{_fieldErrors.last_name}</FieldErrorMessage>}
            </AgentNameWrapper>
            <AgentDetailsWrapper>
              <AgentDetailsInput
                label="MLS #"
                name="mls"
                value={mls}
                onChange={handleInputChange}
                placeholder={'MLS Number'}
                multi={true}
              />
              <AgentDetailsInput
                label="License #"
                name="licenses"
                value={licenses}
                onChange={handleInputChange}
                placeholder={'License Number'}
                multi={true}
              />
              <AgentDetailsInput
                className={(_fieldErrors.first_name && 'has-error') || ''}
                ref={refMobilePhone}
                label="Mobile #"
                name="mobile_phone"
                value={mobile_phone}
                onChange={handleInputChange}
                placeholder={'Mobile Number'}
              />
              {_fieldErrors.mobile_phone && <FieldErrorMessage>{_fieldErrors.mobile_phone}</FieldErrorMessage>}
              <AgentDetailsInput
                label="Extension #"
                name="ywh_ext_num"
                value={ywh_ext_num}
                onChange={handleInputChange}
                placeholder={'Extension Number'}
              />
              <AgentDetailsInput
                label="NHS URL"
                name="showingnew_identifier"
                value={showingnew_identifier}
                onChange={handleInputChange}
                placeholder={'URL Identifier (New Home Source)'}
              />
              <AgentDetailsInput
                label="Subdomain"
                name="subdomain"
                value={subdomain}
                onChange={handleInputChange}
                placeholder="Agent Subdomain"
              />
              <AgentDetailsInputGroup>
                <label>Loan Officer</label>
                <span>:</span>
                <Select
                  name="loan_officer"
                  className='loan-officer-container'
                  classNamePrefix='loan-officer-select'
                  options={officers.map(o => { return {value: o.id, label: o.first_name + ' ' + o.last_name} })}
                  onChange={(option) =>  setData({
                    ...data,
                    ["loan_officer"]: option.value,
                  })}
                />
              </AgentDetailsInputGroup>

            </AgentDetailsWrapper>
          </AgentInfoWrapper>
        </AgentDetail>

        <AgentDetailExtra>
          <AgentContactContainer>
            <AgentContactWrapper>
              <AgentContactListItem
                hasError={(_fieldErrors.brokerage && 'has-error') || ''}
                ref={refBrokerage}
                title="Brokerage"
                name="brokerage"
                value={brokerage}
                onChange={handleInputChange}
                icon="brokerage"
              />
              {_fieldErrors.brokerage && <FieldErrorMessage>{_fieldErrors.brokerage}</FieldErrorMessage>}

              <AgentContactListItem
                title="Company Phone"
                name="company_phone"
                value={company_phone}
                onChange={handleInputChange}
                icon="company-phone"
              />
              <AgentContactListItem
                title="Compensation Plan"
                name="compensation_plan"
                value={compensation_plan}
                onChange={handleInputChange}
                icon="compensation-plan"
              />
              <AgentContactListItem
                title="Team Name"
                name="team_name"
                value={team_name}
                onChange={handleInputChange}
                icon="team-name"
              />
              <AgentContactListItem
                title="Agent Type"
                name="agent_type"
                value={agent_type}
                onChange={handleInputChange}
                icon="agent-type"
              />
            </AgentContactWrapper>
          </AgentContactContainer>
          <AgentAdditionalDetailsContainer>
            <AgentOfficeAddress
              title="Office Address"
              name="office_address"
              value={office_address}
              onChange={handleInputChange}
            />
            <AgentCompanyWebsite company={company_website} personal={personal_website} onChange={handleInputChange} />
            <AgentCityStateServedContainer>
              <AgentCityStateServed
                title="state"
                name="states_served"
                values={states_served}
                onChange={handleSelectChange}
                description="Serving the following States"
              />
              {states_served.length > 0 && (
                <AgentCityStateServed
                  title="city"
                  name="cities_served"
                  values={cities_served}
                  params={states_served}
                  onChange={handleSelectChange}
                  description="Serving Cities and Surrounding Towns"
                />
              )}
              {isAdmin && cities_served.length > 0 && (
                <AgentCityStateServed
                  title="community"
                  name="communities_served"
                  values={communities_served}
                  params={cities_served}
                  onChange={handleSelectChange}
                  description="Serving the following Communities"
                />
              )}
            </AgentCityStateServedContainer>
          </AgentAdditionalDetailsContainer>
        </AgentDetailExtra>

        <AgentDetailsBio
          hasError={(_fieldErrors.description && 'has-error') || ''}
          title="Name"
          ref={refDescription}
          icon="bio-name"
          name="description"
          value={description}
          onChange={handleInputChange}
          subtitle="GET TO KNOW"
          type="text"
        />
        {_fieldErrors.description && <FieldErrorMessage>{_fieldErrors.description}</FieldErrorMessage>}

        {communities_served && communities_served.length > 0 && (
          <AgentDetailsBio
            onChangeFiles={handleChangeFiles}
            title="COMMUNITY"
            icon="bio-community"
            subtitle="EXPLORE THE"
            type="gallery"
            communities={communities_served}
          />
        )}

        <AgentFooter isSubmitting={isSubmitting || silentlyUploading} />
      </AgentPage>
    </form>
  );
};

export default AddAgent;
